/**
 * Header - Full Screen Block JavaScript
 * LCP Optimized: Deferred animations + lazy video loading
 * Video/poster only injected and loaded on desktop (>= 768px) - never on mobile
 */

(function() {
    'use strict';

    const DESKTOP_BREAKPOINT = 768;

    // Initialize block functionality
    function initHeaderFullScreen() {
        const blocks = document.querySelectorAll('.header-full-screen');

        blocks.forEach(block => {
            // Inject and lazy load video only on desktop (never on mobile)
            injectAndLazyLoadVideo(block);

            // Mobile: play video when user scrolls to it
            initMobileVideoScrollPlay(block);

            // Add GSAP animations after content is visible
            initDeferredAnimations(block);

            console.log('[BLOCK] header-full-screen block initialized (LCP optimized)');
        });
    }

    /**
     * Inject video from template only on desktop, then lazy load it.
     * On mobile, video and poster are never loaded (template content stays inert).
     */
    function injectAndLazyLoadVideo(block) {
        if (window.innerWidth < DESKTOP_BREAKPOINT) return;
        // Skip if already initialized
        if (block.querySelector('.video-bg')) return;

        const template = block.querySelector('.header-full-screen-video-template');
        if (!template || !template.content) return;

        const video = template.content.querySelector('video');
        if (!video) return;

        const clone = template.content.cloneNode(true);
        const clonedVideo = clone.querySelector('video');
        const videoContainer = block.querySelector('.video-container');
        const insertTarget = videoContainer || block;
        insertTarget.insertBefore(clone, insertTarget.firstChild);

        let videoLoaded = false;

        // Play when user scrolls to the block, pause when they scroll away
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    if (!videoLoaded) {
                        const sources = clonedVideo.querySelectorAll('source[data-src]');
                        sources.forEach(source => {
                            source.src = source.dataset.src;
                            source.removeAttribute('data-src');
                        });
                        clonedVideo.load();
                        videoLoaded = true;
                        console.log('[BLOCK] Video lazy loaded (desktop only)');
                    }
                    clonedVideo.play().catch(() => {});
                } else {
                    clonedVideo.pause();
                }
            });
        }, { rootMargin: '0px', threshold: 0.25 });

        observer.observe(clonedVideo);
    }

    /**
     * Mobile: play video when user scrolls to the block, pause when they scroll away
     */
    function initMobileVideoScrollPlay(block) {
        if (window.innerWidth >= DESKTOP_BREAKPOINT) return;

        const mobileVideo = block.querySelector('.mobile-video-bg');
        if (!mobileVideo) return;

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    mobileVideo.play().catch(() => {});
                } else {
                    mobileVideo.pause();
                }
            });
        }, { rootMargin: '0px', threshold: 0.25 });

        observer.observe(mobileVideo);
    }

    /**
     * Add GSAP animations after LCP to not block rendering
     */
    function initDeferredAnimations(block) {
        // Wait for GSAP to be available
        if (typeof gsap === 'undefined' || !window.SOJ_GSAP_ANIMATIONS) {
            console.log('[BLOCK] GSAP not available, skipping animations');
            return;
        }

        // Find elements with deferred animation data attributes
        const animatedElements = block.querySelectorAll('[data-gsap-animate]');

        animatedElements.forEach(element => {
            const animationType = element.dataset.gsapAnimate;
            const delay = parseInt(element.dataset.gsapDelay) || 0;

            // Add GSAP classes now that content is visible
            element.classList.add('gsap-fade-in');
            if (delay) {
                element.classList.add(`gsap-delay-${delay}`);
            }
        });

        console.log('[BLOCK] Deferred GSAP animations applied');
    }

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initHeaderFullScreen);
    } else {
        initHeaderFullScreen();
    }
})();